import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Armchair } from "lucide-react";
import { api, C } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const mmss = (ms) => { const s = Math.max(0, Math.ceil(ms / 1000)); return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`; };

// Early-seated but stepped away: a slim live countdown back to the seat (the 2-minute TournamentCall takes over after).
export const SeatWaiting = () => {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const [seat, setSeat] = useState(null);
  const [, tick] = useState(0);
  const onTable = pathname.startsWith("/table/");

  const load = useCallback(() => {
    api.get(C.ApiRoutes.MTT).then((r) => {
      const ev = r.data.find((e) => e.instance?.registered_me && e.instance?.my_table_id && e.instance?.status === "REGISTERING");
      setSeat(ev ? { name: ev.name, table: ev.instance.my_table_id, start: ev.instance.start_at } : null);
    }).catch(() => {});
  }, []);
  useEffect(() => {
    if (!user?.user_id || onTable) return;
    load();
    const i = setInterval(load, 10000);
    return () => clearInterval(i);
  }, [user?.user_id, onTable, load]);
  useEffect(() => { const i = setInterval(() => tick((n) => n + 1), 1000); return () => clearInterval(i); }, []);

  if (!user?.user_id || onTable || !seat) return null;
  const left = seat.start - Date.now();
  if (left <= C.TDA.MTT_CALL_MS) return null;
  return (
    <button data-testid="seat-waiting-pill" onClick={() => nav(`/table/${seat.table}`)}
      className="fixed bottom-6 right-6 z-[65] gold-card rounded-full pl-4 pr-2 py-2 flex items-center gap-3 shadow-2xl rise btn-lift text-left">
      <Armchair className="w-4 h-4 text-amber-300 shrink-0" />
      <span className="flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-[0.25em] text-amber-300/80">Your seat is waiting</span>
        <span className="text-xs text-amber-50 truncate max-w-[12rem]" data-testid="seat-waiting-name">{seat.name}</span>
      </span>
      <span data-testid="seat-waiting-clock" className="font-mono text-lg text-amber-100 tabular-nums">{mmss(left)}</span>
      <span className="btn-gold rounded-full px-3 py-1.5 text-[10px] font-display tracking-wider">RETURN</span>
    </button>
  );
};
